module.exports = __webpack_public_path__ + "static/media/Cascadia.8d18551f.ttf";